import { Box, FormControl, FormLabel, Text } from '@chakra-ui/react';
import { Select as ReactSelect } from 'chakra-react-select';
import { ORG_ROLE_OPTIONS } from '../../../../members/components/table/resources/invitationResources';

interface OrganizationAccessFieldProps {
  boldText?: boolean;
}

// Get current user's organization role - always preselect "User"
const getCurrentUserOrgRole = () =>
  ORG_ROLE_OPTIONS.find((option) => option.value === 'Organization User') ||
  ORG_ROLE_OPTIONS[2];

const formatOptionLabel = ({
  label,
  desc,
}: {
  label: string;
  desc: string;
  value: string;
}) => (
  <Text fontSize='md' data-testid={`option-${label}`}>
    <span style={{ fontWeight: 'semibold' }}>{label}</span> - {desc}
  </Text>
);

export const OrganizationAccessField = ({
  boldText = false,
}: OrganizationAccessFieldProps) => {
  const currentUserRole = getCurrentUserOrgRole();

  return (
    <FormControl py={2}>
      <FormLabel htmlFor='organization-access-select-input-id'>
        <Text
          mb='4'
          {...(boldText && { fontWeight: 'bold', color: 'blackAlpha.800' })}
        >
          Organization access
        </Text>
      </FormLabel>
      <Box data-testid='create-team-drawer-org-access'>
        <ReactSelect
          selectedOptionColorScheme='primary'
          inputId='organization-access-select-input-id'
          value={currentUserRole}
          isDisabled={true}
          options={ORG_ROLE_OPTIONS}
          formatOptionLabel={formatOptionLabel}
        />
      </Box>
    </FormControl>
  );
};
